var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo__inner",class:{ 'logo__inner--redirect': _vm.redirect },attrs:{"src":_vm.src},on:{"click":_vm.handleClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }